import React, { component, useState, useEffect } from 'react';
import Players from './Players';

import Sticky from "../Sticky";

//import {Router} from 'react-router-dom';



function PlayersPage() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(
      'https://kerckhoff.dailybruin.com/api/packages/flatpages/flatpage.2022.bhm/'
    )
      .then((res) => res.json())
      .then((res) => setData(res.data['article.aml']));
  }, []);

  data && console.log(data);

  const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    console.log(isMobile);
    //console.log(data);
    media.addEventListener('change', () => {
        if (media.matches !== isMobile) {
          setIsMobile(media.matches);
        }
    });
    
      return (
        (data &&
        <>
            <p>WOMENS</p>
            <Players mf='f'/>
            <p>MENS</p>
            <Players mf='f' />
          </>
        )
      );
}

export default PlayersPage;